import React from 'react';

export const FaceLaughingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M25.8971 25.8985C32.4975 19.2981 31.364 11.568 25.8971 6.10112C20.4302 0.634212 12.7001 -0.499337 6.09965 6.10112C-0.500802 12.7016 0.632747 20.4316 6.09965 25.8985C11.5666 31.3654 19.2966 32.499 25.8971 25.8985Z"
        fill="#FFB02E"
      />
      <path
        d="M15.0513 5.78463C15.2259 5.26069 15.7922 4.97753 16.3162 5.15217C16.8401 5.32682 17.1233 5.89314 16.9486 6.41709L16.1669 8.76236L18.5121 7.9806C19.0361 7.80595 19.6024 8.08911 19.777 8.61306C19.9517 9.137 19.6685 9.70332 19.1446 9.87797L14.9019 11.2922C14.5426 11.412 14.1464 11.3184 13.8786 11.0506C13.6108 10.7828 13.5173 10.3866 13.637 10.0273L15.0513 5.78463Z"
        fill="#402A32"
      />
      <path
        d="M5.78439 15.0516C5.26044 15.2263 4.97728 15.7926 5.15193 16.3165C5.32658 16.8405 5.8929 17.1236 6.41684 16.949L8.76212 16.1672L7.98036 18.5125C7.80571 19.0364 8.08887 19.6028 8.61281 19.7774C9.13676 19.9521 9.70308 19.6689 9.87772 19.145L11.2919 14.9023C11.4117 14.543 11.3182 14.1468 11.0504 13.879C10.7825 13.6111 10.3864 13.5176 10.027 13.6374L5.78439 15.0516Z"
        fill="#402A32"
      />
      <path
        d="M22.3639 22.3642C15.9999 28.7281 9.63599 22.3642 9.63599 22.3642L22.3639 9.63623C22.3639 9.63623 28.7279 16.0002 22.3639 22.3642Z"
        fill="#BB1D80"
      />
      <path
        d="M10.6966 22.0105L10.343 21.657L21.6567 10.3433L22.0103 10.6968C22.4008 11.0873 22.4008 11.7205 22.0103 12.111L12.1108 22.0105C11.7203 22.401 11.0871 22.401 10.6966 22.0105Z"
        fill="white"
      />
      <path
        d="M11.0503 22.364V27.1296C11.0503 28.3707 9.98954 29.3467 8.75277 29.2436C7.65331 29.152 6.80762 28.2329 6.80762 27.1296L6.80762 22.364C6.80762 21.1924 7.75737 20.2427 8.92894 20.2427C10.1005 20.2427 11.0503 21.1924 11.0503 22.364Z"
        fill="#3F5FFF"
      />
      <path
        d="M22.5408 10.8735H27.3064C28.5474 10.8735 29.5234 9.81278 29.4204 8.57601C29.3287 7.47655 28.4096 6.63086 27.3064 6.63086L22.5408 6.63086C21.3692 6.63086 20.4194 7.58061 20.4194 8.75218C20.4194 9.92375 21.3692 10.8735 22.5408 10.8735Z"
        fill="#3F5FFF"
      />
    </svg>
  );
};
